export default __webpack_public_path__ + "static/media/data.d4b1e46e.png";